export const VILLA_LOCATION_ROUTE_QUERY_KEYS = [
  "locationType",
  "cityTitle",
  "category",
  "categorySlug"
] as const;

export type ResolvedVillaSeoCategory = {
  publicSlug: string;
  backendSlug: string;
  id: number;
  title: string;
};

export type VillaSeoCategoryRecord = {
  id?: number;
  slug?: string;
  title?: string;
  is_active?: boolean;
  isActive?: boolean;
  active?: boolean;
  enabled?: boolean;
  status?: boolean | number | string;
};

const VILLA_SEO_CATEGORIES = [
  "villa",
  "jungle",
  "beach",
  "pool",
  "mountain",
  "apartment",
  "ecotourism"
] as const;

export const getVillaSeoCategoryBackendSlug = (publicSlug: string) =>
  VILLA_SEO_CATEGORIES.find((category) => category === publicSlug);

export const getVillaSeoCategoryCanonicalRoute = (
  basePathname: string,
  locationType: string,
  cityTitle: string
) => `${basePathname}/${locationType}/${cityTitle}`;

export const resolveVillaSeoCategory = (
  publicSlug: string,
  category: VillaSeoCategoryRecord
): ResolvedVillaSeoCategory | null => {
  const backendSlug = getVillaSeoCategoryBackendSlug(publicSlug);
  const id = Number(category?.id);
  const isEnabled =
    category.is_active !== false &&
    category.isActive !== false &&
    category.active !== false &&
    category.enabled !== false &&
    category.status !== false &&
    category.status !== 0 &&
    category.status !== "disabled" &&
    category.status !== "inactive";

  if (!backendSlug || !Number.isFinite(id) || id <= 0 || !isEnabled) {
    return null;
  }

  return {
    publicSlug,
    backendSlug,
    id,
    title: category.title || backendSlug
  };
};

export const applyVillaSeoCategoryDefault = <
  Query extends Record<string, unknown> = Record<string, unknown>
>(
  query: Query,
  seoCategory?: Pick<ResolvedVillaSeoCategory, "id">
): Query => {
  if (!seoCategory || Object.hasOwn(query, "property_categories")) {
    return query;
  }

  return {
    ...query,
    property_categories: String(seoCategory.id)
  } as Query;
};
